import { DeepLinkState } from '@core/deep-link/store/states/deep-link.state';

export const deepLinkState = [DeepLinkState];
